module.exports = __webpack_public_path__ + "static/media/logoBVQ2.4c2c364e.svg";